import '@d3fc/d3fc-element';
import { SymbolTileDataTimeSeriesItem } from 'widgets/symbolTile/components/symbolTileData';
import { line } from 'utils/components/TimeSeriesChart/line';

export const priceLine = line<SymbolTileDataTimeSeriesItem>(
    (d) => d.price,
    'price-line'
);
